import type { BaseEntity } from "@/components/shared/UniversalCRMTable/types/base-types";
import type { GroupedDataItem } from "./types";
import { getRelationValue } from "../../relation/relation-helpers";

type GroupDataMeta = {
  type: "data";
  groupKey?: string;
  groupLabel?: string;
  groupKeys?: string[];
  groupPath?: string[];
};

export function asDataItem<T extends BaseEntity>(item: T, meta: GroupDataMeta): GroupedDataItem<T> {
  return { ...item, ...meta } as GroupedDataItem<T>;
}

export function getGroupingValue(item: BaseEntity, fieldId: string): unknown {
  return getRelationValue(item, fieldId);
}
